// 请求响应相关
import axios from 'axios'
import { Notification, MessageBox } from 'element-ui'
// 创建 axios 实例
const service = axios.create({
  baseURL: '',
  timeout: 90000, // 请求超时时间
})
let errorCount = 0
let timer = setInterval(() => {
  errorCount = 0
}, 8000)

const err = (error) => {
  // 登录超时，接口请求多次，导致弹框会多次出现，方案：只弹一次
  if (errorCount === 0) {
    if (error.response) {

      let data = error.response.data
      switch (error.response.status) {
        case 400:
          Notification.error({
            title: translate('System prompt'),
            message: translate('Parameter error'),
            duration: 4000,
          })
          break
        case 401:
          break
        case 403:
          Notification.error({
            title: translate('System prompt'),
            message: translate('Access denied'),
            duration: 4000,
          })
          break
        case 404:
          Notification.error({
            title: translate('System prompt'),
            message: translate('Sorry, the resource was not found'),
            duration: 4000,
          })
          break
        case 412:
          Notification.error({
            title: translate('System prompt'),
            message: translate(data),
            duration: 4000,
          })
          MessageBox.confirm(translate(data), '', {
            confirmButtonText: translate('Confirm'),
            cancelButtonText: translate('Cancel'),
            type: 'error',
            closeOnClickModal: false,
            closeOnPressEscape: false,
          }).then(() => {
          }).catch(() => {
          })
          break
        case 500:
          Notification.error({
            title: translate('System prompt'),
            message: translate('System Error'),
            duration: 4000,
          })
          break
        default:
          Notification.error({
            message: translate('System prompt'),
            description: translate(data),
            duration: 4000,
          })
          break
      }
    }
  }
  errorCount++
  return Promise.reject(error)
}

// request interceptor
service.interceptors.request.use(
  (config) => {
    try {
      window.marketingPortalUserTracking({
        url: window.location.href,
        cookie: document.cookie,
        body: config.data,
        requestUrl: config.baseURL + config.url,
        requestMethod: config.method
      })
    } catch (error) {
      
    }
    config.headers['X-tenant-id'] = window.VUE_APP_X_tenant_id
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

// response interceptor
service.interceptors.response.use((response) => {
  if (response.headers['content-disposition']) {
    return response
  }
  return response.data
}, err)



export { service as axios }



// WEBPACK FOOTER //
// ./src/packages/chatBox/components/request.js